import Vue from 'vue'
import Router from 'vue-router'
import { fsSetRoute } from '@/utils/fullstory'
import { isFeatureEnabled } from '@/utils/alerts_access'

import dashboard from '@/components/main_dashboard'
import actuals from '@/components/actuals'
import actuals_tbn from '@/components/actuals_tbn'
import actuals_troubleshooter from '@/components/actuals_troubleshooter'
import actuals_stats from '@/components/actuals_stats'
import driver_actuals from '@/components/driver_actuals'
import driver_actuals_tbn from '@/components/driver_actuals_tbn'
import vehicle_actuals from '@/components/vehicle_actuals'
import vehicle_actuals_tbn from '@/components/vehicle_actuals_tbn'
import booking_customer_list_tbn from '@/components/booking_customer_list_tbn'
import booking_customer_detail_tbn from '@/components/booking_customer_detail_tbn'
import booking_customer_fleet_map from '@/components/booking_customer_fleet_map'
import actuals_fasttrak from '@/components/actuals_fasttrak'
import booking_feed from '@/components/booking_feed'
import booking_dashboard from '@/components/booking_dashboard'
import arrivals_departures_board from '@/components/arrivals_departures_board'
import arrivals_departures_board_large from '@/components/arrivals_departures_board_large'
import bus_tracker from '@/components/bus_tracker'
import driver_contacts from '@/components/driver_contacts'
import actuals_mileage_tbn from '@/components/actuals_mileage_tbn'
import actuals_mileage_cm from '@/components/actuals_mileage_cm'
//import tenant_config from '@/components/tenant_config'
import report_shell from '@/components/report_shell'
import report_dashboard_shell from '@/components/report_dashboard_shell'
import map_dashboard_shell from '@/components/map_dashboard_shell'
import map_shell from '@/components/map_shell'
import booking_shell from '@/components/booking_shell'
import booking_dashboard_shell from '@/components/booking_dashboard_shell'
import vsm_shell from '@/components/vsm_shell'
import alerts_shell from '@/components/alerts_shell'
import tenant_config_shell from '@/components/tenant_config_shell'
import tenant_config_history from '@/components/tenant_config_history'
import tenant_config_general from '@/components/tenant_config_general'
import tenant_config_bookings_actuals from '@/components/tenant_config_bookings_actuals'
import tenant_config_cust_map_views from '@/components/tenant_config_cust_map_views'
import tenant_config_views_reports from '@/components/tenant_config_views_reports'
import tenant_config_alerts from '@/components/tenant_config_alerts'
import tenant_config_notifications from '@/components/tenant_config_notifications'
import tenant_config_bus_sos from '@/components/tenant_config_bus_sos'
import tenant_config_veh_status_mgmt from '@/components/tenant_config_veh_status_mgmt'
import tenant_config_data_services from '@/components/tenant_config_data_services'
import tenant_config_fleet_assistant from '@/components/tenant_config_fleet_assistant'
import url_shortener from '@/components/url_shortener'

import tenant_manager from '@/components/tenant_manager'
import admin_manage_users from '@/components/admin_manage_users'
import admin_settings_history from '@/components/admin_settings_history'
import admin_dashboard from '@/components/admin_dashboard'
import cache_manager from '@/components/cache_manager'
import admin_tools_dashboard from '@/components/admin_tools_dashboard'
import admin_shell from '@/components/admin_shell'
import planned_vehicle_daily from '@/components/planned_vehicle_daily'
import planned_vehicle_daily_tbn from '@/components/planned_vehicle_daily_tbn'
import planned_drivers_daily_tbn from '@/components/planned_drivers_daily_tbn'
import planned_drivers_daily from '@/components/planned_drivers_daily'
import login from "@/components/login"
import planned_vehicle_weekly from "@/components/planned_vehicle_weekly";
import planned_vehicle_weekly_tbn from "@/components/planned_vehicle_weekly_tbn";
import planned_drivers_weekly_dispatch_tbn from "@/components/planned_drivers_weekly_dispatch_tbn";
import planned_drivers_weekly_util_tbn from "@/components/planned_drivers_weekly_util_tbn";
import booking_monthly_view_tbn from "@/components/booking_monthly_view_tbn";
import hale_daily_dispatch_report_tbn from "@/components/hale_daily_dispatch_report_tbn";
import planned_vehicle_types_monthly from "@/components/planned_vehicle_types_monthly";
import planned_vehicle_types_monthly_tbn from "@/components/planned_vehicle_types_monthly_tbn";
import planned_driver_types_monthly_tbn from "@/components/planned_driver_types_monthly_tbn";
import planned_driver_types_monthly_cm from "@/components/planned_driver_types_monthly_cm";
import vehicle_map from "@/components/vehicle_map";
import vehicle_map_future from "@/components/vehicle_map_future";
import vehicle_map_direct from "@/components/vehicle_map_direct";
import vehicle_map_driver from "@/components/vehicle_map_driver";
import vehicle_map_track from "@/components/vehicle_map_track";
import vehicle_trip_history from "@/components/vehicle_trip_history";
import vehicle_route_history from "@/components/vehicle_route_history";
import vehicle_map_track_fleet from "@/components/vehicle_map_track_fleet";
import vehicle_map_track_fleet_fabbus from "@/components/vehicle_map_track_fleet_fabbus";
import vehicle_map_by_booking from "@/components/vehicle_map_by_booking";
import vehicle_map_link from "@/components/vehicle_map_link";
import map_link_builder from "@/components/map_link_builder";
import direct_register from "@/components/direct_register";
import report_unplanned_vehicle from "@/components/report_unplanned_vehicle";
import report_unplanned_hos from "@/components/report_unplanned_hos";
import report_otp from "@/components/report_otp";
import otp_history from "@/components/otp_history";
import actuals_billing_report from "@/components/actuals_billing_report";
import actuals_vehicle_report from "@/components/actuals_vehicle_report";
import smart_route_assignments from "@/components/smart_route_assignments";
import smart_route_assignments_tbn from "@/components/smart_route_assignments_tbn";
import actuals_billing_report_tbn from "@/components/actuals_billing_report_tbn";
import intrastate_booking_report_tbn from "@/components/intrastate_booking_report_tbn";
import trip_linker_report_tbn from "@/components/trip_linker_report_tbn";
import actuals_start_events_report_tbn from "@/components/actuals_start_events_report_tbn";
import actuals_driver_payroll_report from "@/components/actuals_driver_payroll_report";
import actuals_driver_payroll_report_tbn from "@/components/actuals_driver_payroll_report_tbn";
import announcement_detail from "@/components/announcement_detail";
import notifications_list from "@/components/notifications_list";
import actuals_drivers_daily_report from "@/components/actuals_drivers_daily_report";
import actuals_driver_multiday_report from "@/components/actuals_driver_multiday_report";
import actuals_hours_by_client_report from "@/components/actuals_hours_by_client_report";
import actuals_hours_by_client_report_tbn from "@/components/actuals_hours_by_client_report_tbn";
import actuals_hours_by_booking_report_tbn from "@/components/actuals_hours_by_booking_report_tbn";
import actuals_mileage_by_booking_report from "@/components/actuals_mileage_by_booking_report";
import actuals_driver_multiday_report_tbn from "@/components/actuals_driver_multiday_report_tbn";
import actuals_payroll_summary_report_tbn from "@/components/actuals_payroll_summary_report_tbn";
import actuals_payroll_summary_report from "@/components/actuals_payroll_summary_report";
import actuals_perf_report from "@/components/actuals_perf_report";
import actuals_multiday_otp_report from "@/components/actuals_multiday_otp_report";
import actuals_on_time_report from "@/components/actuals_on_time_report";
import actuals_perf_report_tbn from "@/components/actuals_perf_report_tbn";
import actuals_multiday_otp_report_tbn from "@/components/actuals_multiday_otp_report_tbn";
import actuals_on_time_report_tbn from "@/components/actuals_on_time_report_tbn";
import group_message_sender from "@/components/group_message_sender.vue";
import group_message_sender_tbn from "@/components/group_message_sender_tbn.vue";
// support_ticket_list and support_ticket_details are no longer imported:
// both routes are pure redirects into help_center now.
import support_ticket_create from "@/components/support_ticket_create.vue";
import ops_desk from "@/components/ops_desk.vue";
import ops_board from "@/components/ops_board.vue";
import erm_board from "@/components/erm_board.vue";
import ops_desk_public_form from "@/components/ops_desk_public_form.vue";
import vsm_board from "@/components/vsm_board.vue";
import departure_board from "@/components/departure_board.vue";
import fleet_assistant from "@/components/fleet_assistant.vue";
import help_center from "@/components/help_center.vue";
import site_map from '@/components/site_map'

import user_list from "@/components/user_list.vue";
import driver_list from "@/components/driver_list.vue";
import driver_list_tbn from "@/components/driver_list_tbn.vue";
import route_addresses from "@/components/route_addresses.vue";
import route_assignments from "@/components/route_assignments.vue";
import report_converter from "@/components/report_converter.vue";
import user_detail from "@/components/user_detail.vue";
import driver_detail from "@/components/driver_detail.vue";
import driver_detail_tbn from "@/components/driver_detail_tbn.vue";
import user_create from "@/components/user_create.vue";
import alert_list from "@/components/alert_list";
import alerts_dashboard from "@/components/alerts_dashboard";
import delivery_failures from "@/components/delivery_failures";
import hos_history_report from "@/components/hos_history_report";
import tyler_route_processor from "@/components/tyler_route_processor";
import compare_drivers from "@/components/compare_drivers";
import compare_driver_profiles from "@/components/compare_driver_profiles";
import compare_drivers_history from "@/components/compare_drivers_history";
import driver_manager_dashboard from "@/components/driver_manager_dashboard";
import driver_manager_roster_list from "@/components/driver_manager_roster_list";
import driver_manager_individual from "@/components/driver_manager_individual";
import driver_manager_compare from "@/components/driver_manager_compare";
import coaching_portal from "@/components/coaching_portal";
import coaching_stats from "@/components/coaching_stats";
import coaching_board from "@/components/coaching_board";
import coaching_flagged from "@/components/coaching_flagged";
import coaching_recognition from "@/components/coaching_recognition";
import driver_comparison from "@/components/driver_comparison";
import booking_file_list from "@/components/booking_file_list";
import booking_update_history from "@/components/booking_update_history";
import overlap_updates_history from "@/components/overlap_updates_history";
import actuals_simulator from "@/components/actuals_simulator";
import event_notes_list from "@/components/event_notes_list";
import vehicle_status from "@/components/vehicle_status";
import vehicle_status_es from "@/components/vehicle_status_es";
import vehicle_status_history from "@/components/vehicle_status_history";
import vehicle_status_dvir from "@/components/vehicle_status_dvir";
import vehicle_status_dvir_fasttrak from "@/components/vehicle_status_dvir_fasttrak";
import vehicle_status_dvir_tbn from "@/components/vehicle_status_dvir_tbn";
import vehicle_status_maint_tbn from "@/components/vehicle_status_maint_tbn";
import vehicle_status_maint from "@/components/vehicle_status_maint";
import vehicle_status_tbn from "@/components/vehicle_status_tbn";
import vehicle_status_upcoming from "@/components/vehicle_status_upcoming";
import vehicle_status_upcoming_tbn from "@/components/vehicle_status_upcoming_tbn";
import trip_sheet_tbn from "@/components/trip_sheet_tbn";
import driver_board from "@/components/driver_board";
import vehicle_maint_summary from "@/components/vehicle_maint_summary";
import trip_sheet from "@/components/trip_sheet";
import dispatch_board_tbn from "@/components/dispatch_board_tbn";
import driver_bid_board_tbn from "@/components/driver_bid_board_tbn";
import sos_list from "@/components/sos_list";
import sos_detail from "@/components/sos_detail.vue";
import process_manager_list from "@/components/process_manager_list";
import driver_bid_manager_board_tbn from '../components/driver_bid_manager_board_tbn'
import api_usage_dashboard from '@/components/api_usage_dashboard'
import sms_usage_dashboard from '@/components/sms_usage_dashboard'

Vue.use(Router)

let router = new Router({

    routes: [
        {
            path: '/',
            redirect: { name: 'login' }
        }, {
            path: '/login',
            name: 'login',
            component: login
        }, {
            path: '/login/:nextUrl',
            name: 'login_redirect',
            component: login
        }, {
            path: '/dashboard',
            name: 'dashboard',
            component: dashboard,
        }, {
            path: '/site_map',
            name: 'site_map',
            component: site_map,
        }, {
            path: '/admin-tools',
            component: admin_shell,
            children: [
                { path: '',                  name: 'admin_tools_dashboard', component: admin_tools_dashboard },
                { path: 'admin_dashboard',   name: 'admin_dashboard',       component: admin_dashboard },
                { path: 'manage_users',      name: 'admin_manage_users',    component: admin_manage_users },
                { path: 'settings_history',  name: 'admin_settings_history', component: admin_settings_history },
                { path: 'tenant_manager',    name: 'tenant_manager',        component: tenant_manager },
                { path: 'api_usage',         name: 'api_usage_dashboard',   component: api_usage_dashboard },
                { path: 'sms_usage',         name: 'sms_usage_dashboard',   component: sms_usage_dashboard },
                { path: 'process_manager',   name: 'process_manager_list',  component: process_manager_list },
                { path: 'actuals_simulator', name: 'actuals_simulator',     component: actuals_simulator },
                { path: 'url_shortener',     name: 'url_shortener',         component: url_shortener },
                { path: 'cache_manager',     name: 'cache_manager',         component: cache_manager },
            ],
        }, {
            // ── Bookings section (persistent shell + nested child routes) ──────
            path: '/bookings',
            component: booking_shell,
            children: [
                { path: '',                    name: 'bookings_dashboard',  component: booking_dashboard_shell },
                { path: 'actuals',             name: 'actuals',             component: actuals },
                { path: 'actuals_tbn',         name: 'actuals_tbn',         component: actuals_tbn },
                { path: 'driver_actuals',      name: 'driver_actuals',      component: driver_actuals },
                { path: 'driver_actuals_tbn',  name: 'driver_actuals_tbn',  component: driver_actuals_tbn },
                { path: 'vehicle_actuals',     name: 'vehicle_actuals',     component: vehicle_actuals },
                { path: 'vehicle_actuals_tbn', name: 'vehicle_actuals_tbn', component: vehicle_actuals_tbn },
                { path: 'actuals_fasttrak',    name: 'actuals_fasttrak',    component: actuals_fasttrak },
                { path: 'actuals_troubleshooter',    name: 'actuals_troubleshooter',    component: actuals_troubleshooter },
                { path: 'actuals_stats', name: 'actuals_stats', component: actuals_stats },
                { path: 'booking_file_list',         name: 'booking_file_list',         component: booking_file_list },
                { path: 'booking_update_history',     name: 'booking_update_history',     component: booking_update_history },
                { path: 'overlap_updates_history',  name: 'overlap_updates_history',  component: overlap_updates_history },
            ],
        }, {
            path: '/booking_dashboard',
            name: 'booking_dashboard',
            component: booking_dashboard,
        }, {
            path: '/arrivals_departures_board_large',
            name: 'arrivals_departures_board_large',
            component: arrivals_departures_board_large,
        }, {
            path: '/booking_feed',
            name: 'booking_feed',
            component: booking_feed,
        }, {
            path: '/booking-customer',
            name: 'booking_customer_list_tbn',
            component: booking_customer_list_tbn,
            meta: { keepAlive: true },
        }, {
            path: '/booking-customer/:tbn_booking_hash',
            name: 'booking_customer_detail_tbn',
            component: booking_customer_detail_tbn,
        }, {
            path: '/booking-customer-map',
            name: 'booking_customer_fleet_map',
            component: booking_customer_fleet_map,
        },
        // ── Backward-compat redirects (old flat actuals paths → booking shell) ─
        { path: '/actuals',             redirect: { name: 'actuals' } },
        { path: '/actuals_tbn',         redirect: { name: 'actuals_tbn' } },
        { path: '/driver_actuals',      redirect: { name: 'driver_actuals' } },
        { path: '/driver_actuals_tbn',  redirect: { name: 'driver_actuals_tbn' } },
        { path: '/vehicle_actuals',     redirect: { name: 'vehicle_actuals' } },
        { path: '/vehicle_actuals_tbn', redirect: { name: 'vehicle_actuals_tbn' } },
        { path: '/actuals_fasttrak',    redirect: { name: 'actuals_fasttrak' } },
        {
            path: '/actuals_troubleshooter',
            redirect: to => ({ name: 'actuals_troubleshooter', query: to.query }),
        }, {
            path: '/actuals_stats',
            redirect: to => ({ name: 'actuals_stats', query: to.query }),
        }, {
            path: '/actuals_planned_vs_actual',
            redirect: to => ({ name: 'actuals_stats', query: to.query }),
        }, 
        // {
        //     path: '/tenant_config',
        //     name: 'tenant_config',
        //     component: tenant_config,
        // }, 
        // ── Reports section (persistent shell + nested child routes) ──────
        {
            path: '/reports',
            component: report_shell,
            children: [
                { path: '',                                   name: 'report_dashboard',                       component: report_dashboard_shell },
                // Actuals
                { path: 'actuals_perf_report',                name: 'actuals_perf_report',                    component: actuals_perf_report },
                { path: 'actuals_perf_report_tbn',            name: 'actuals_perf_report_tbn',                component: actuals_perf_report_tbn },
                { path: 'actuals_multiday_otp_report',        name: 'actuals_multiday_otp_report',            component: actuals_multiday_otp_report },
                { path: 'actuals_on_time_report',             name: 'actuals_on_time_report',                 component: actuals_on_time_report },
                { path: 'actuals_multiday_otp_report_tbn',    name: 'actuals_multiday_otp_report_tbn',        component: actuals_multiday_otp_report_tbn },
                { path: 'actuals_on_time_report_tbn',         name: 'actuals_on_time_report_tbn',             component: actuals_on_time_report_tbn },
                { path: 'actuals_billing_report',             name: 'actuals_billing_report',                 component: actuals_billing_report },
                { path: 'actuals_billing_report_tbn',         name: 'actuals_billing_report_tbn',             component: actuals_billing_report_tbn },
                { path: 'actuals_start_events_report_tbn',    name: 'actuals_start_events_report_tbn',        component: actuals_start_events_report_tbn },
                { path: 'actuals_driver_payroll_report',      name: 'actuals_driver_payroll_report',          component: actuals_driver_payroll_report },
                { path: 'actuals_driver_payroll_report_tbn',  name: 'actuals_driver_payroll_report_tbn',      component: actuals_driver_payroll_report_tbn },
                { path: 'actuals_driver_multiday_report',     name: 'actuals_driver_multiday_report',         component: actuals_driver_multiday_report },
                { path: 'actuals_driver_multiday_report_tbn', name: 'actuals_driver_multiday_report_tbn',     component: actuals_driver_multiday_report_tbn },
                { path: 'actuals_payroll_summary_report',     name: 'actuals_payroll_summary_report',         component: actuals_payroll_summary_report },
                { path: 'actuals_payroll_summary_report_tbn', name: 'actuals_payroll_summary_report_tbn',     component: actuals_payroll_summary_report_tbn },
                { path: 'actuals_vehicle_report',             name: 'actuals_vehicle_report',                 component: actuals_vehicle_report },
                { path: 'actuals_mileage_by_booking_report',  name: 'actuals_mileage_by_booking_report',      component: actuals_mileage_by_booking_report },
                { path: 'actuals_drivers_daily_report',       name: 'actuals_drivers_daily_report',           component: actuals_drivers_daily_report },
                { path: 'actuals_hours_by_client_report',     name: 'actuals_hours_by_client_report',         component: actuals_hours_by_client_report },
                { path: 'actuals_hours_by_client_report_tbn', name: 'actuals_hours_by_client_report_tbn',     component: actuals_hours_by_client_report_tbn },
                { path: 'actuals_hours_by_booking_report_tbn',name: 'actuals_hours_by_booking_report_tbn',    component: actuals_hours_by_booking_report_tbn },
                { path: 'intrastate_booking_report_tbn',      name: 'intrastate_booking_report_tbn',          component: intrastate_booking_report_tbn },
                { path: 'hos_history_report',                 name: 'hos_history_report',                     component: hos_history_report },
                // Planned
                { path: 'planned_vehicle_daily',              name: 'planned_vehicle_daily',                  component: planned_vehicle_daily },
                { path: 'planned_vehicle_daily_tbn',          name: 'planned_vehicle_daily_tbn',              component: planned_vehicle_daily_tbn },
                { path: 'planned_vehicle_weekly',             name: 'planned_vehicle_weekly',                 component: planned_vehicle_weekly },
                { path: 'planned_vehicle_weekly_tbn',         name: 'planned_vehicle_weekly_tbn',             component: planned_vehicle_weekly_tbn },
                { path: 'planned_vehicle_types_monthly',      name: 'planned_vehicle_types_monthly',          component: planned_vehicle_types_monthly },
                { path: 'planned_vehicle_types_monthly_tbn',  name: 'planned_vehicle_types_monthly_tbn',      component: planned_vehicle_types_monthly_tbn },
                { path: 'planned_drivers_daily',              name: 'planned_drivers_daily',                  component: planned_drivers_daily },
                { path: 'planned_drivers_daily_tbn',          name: 'planned_drivers_daily_tbn',              component: planned_drivers_daily_tbn },
                { path: 'planned_driver_types_monthly_cm',    name: 'planned_driver_types_monthly_cm',        component: planned_driver_types_monthly_cm },
                { path: 'planned_driver_types_monthly_tbn',   name: 'planned_driver_types_monthly_tbn',       component: planned_driver_types_monthly_tbn },
                { path: 'planned_drivers_weekly_dispatch_tbn',name: 'planned_drivers_weekly_dispatch_tbn',     component: planned_drivers_weekly_dispatch_tbn },
                { path: 'planned_drivers_weekly_util_tbn',    name: 'planned_drivers_weekly_util_tbn',        component: planned_drivers_weekly_util_tbn },
                { path: 'booking_monthly_view_tbn',           name: 'booking_monthly_view_tbn',               component: booking_monthly_view_tbn },
                { path: 'hale_daily_dispatch_report_tbn',     name: 'hale_daily_dispatch_report_tbn',         component: hale_daily_dispatch_report_tbn },
                { path: 'driver_board',                       name: 'driver_board',                           component: driver_board },
                { path: 'trip_sheet',                         name: 'trip_sheet',                             component: trip_sheet },
                { path: 'trip_sheet_tbn',                     name: 'trip_sheet_tbn',                         component: trip_sheet_tbn },
                { path: 'dispatch_board_tbn',                 name: 'dispatch_board_tbn',                     component: dispatch_board_tbn },
                // OTP
                { path: 'vehicle_route_history',              name: 'vehicle_route_history',                  component: vehicle_route_history },
                { path: 'vehicle_route_history/:vehicleId',   name: 'vehicle_route_history_by_id',            component: vehicle_route_history },
                { path: 'route_addresses',                    name: 'route_addresses',                        component: route_addresses },
                { path: 'route_assignments',                  name: 'route_assignments',                      component: route_assignments },
                { path: 'report_otp',                         name: 'report_otp',                             component: report_otp },
                { path: 'otp_history',                        name: 'otp_history',                            component: otp_history },
                // Misc
                { path: 'report_unplanned_vehicle',           name: 'report_unplanned_vehicle',               component: report_unplanned_vehicle },
                { path: 'report_unplanned_hos',               name: 'report_unplanned_hos',                   component: report_unplanned_hos },
                { path: 'event_notes_list',                   name: 'event_notes_list',                       component: event_notes_list },
                { path: 'bus_tracker',                        name: 'bus_tracker',                            component: bus_tracker },
                { path: 'arrivals_departures_board',          name: 'arrivals_departures_board',              component: arrivals_departures_board },
                { path: 'tyler_route_processor',              name: 'tyler_route_processor',                  component: tyler_route_processor },
                { path: 'vehicle_status_history',             redirect: '/vehicle_status_history' },
                { path: 'report_converter',                   name: 'report_converter',                       component: report_converter },
                { path: 'vehicle_maint_summary',              name: 'vehicle_maint_summary',                  component: vehicle_maint_summary },
            ],
        },
        // ── Backward-compat redirects (old admin tool paths → admin shell) ─
        { path: '/admin_dashboard', redirect: { name: 'admin_dashboard' } },
        { path: '/tenant_manager',  redirect: { name: 'tenant_manager' } },
        { path: '/api_usage',       redirect: { name: 'api_usage_dashboard' } },
        { path: '/processmgr',      redirect: { name: 'process_manager_list' } },
        { path: '/actuals_simulator', redirect: { name: 'actuals_simulator' } },
        { path: '/url_shortener',   redirect: { name: 'url_shortener' } },
        { path: '/cache_manager',   redirect: { name: 'cache_manager' } },
        // ── Backward-compat redirects (old flat paths → named report routes) ─
        { path: '/report-dashboard',                   redirect: { name: 'report_dashboard' } },
        {
            path: '/maps',
            component: map_shell,
            children: [
                { path: '',                          name: 'map_dashboard',          component: map_dashboard_shell },
                { path: 'fleet',                     name: 'map_fleet',              component: vehicle_map },
                { path: 'future',                    name: 'map_future',             component: vehicle_map_future },
                { path: 'trip-history',              name: 'map_trip_history',       component: vehicle_trip_history },
                { path: 'trip-history/:vehicleId',   name: 'map_trip_history_by_id', component: vehicle_trip_history },
                { path: 'route-history',             name: 'map_route_history',      component: vehicle_route_history },
                { path: 'route-history/:vehicleId',  name: 'map_route_history_by_id',component: vehicle_route_history },
                { path: 'link-builder',              name: 'map_link_builder',       component: map_link_builder },
            ],
        },
        { path: '/map-dashboard',                      redirect: { name: 'map_dashboard' } },
        { path: '/actuals_perf_report',                redirect: { name: 'actuals_perf_report' } },
        { path: '/actuals_perf_report_tbn',            redirect: { name: 'actuals_perf_report_tbn' } },
        { path: '/actuals_multiday_otp_report',        redirect: { name: 'actuals_multiday_otp_report' } },
        { path: '/actuals_on_time_report',             redirect: { name: 'actuals_on_time_report' } },
        { path: '/actuals_multiday_otp_report_tbn',    redirect: { name: 'actuals_multiday_otp_report_tbn' } },
        { path: '/actuals_on_time_report_tbn',         redirect: { name: 'actuals_on_time_report_tbn' } },
        { path: '/actuals_billing_report',             redirect: { name: 'actuals_billing_report' } },
        { path: '/actuals_billing_report_tbn',         redirect: { name: 'actuals_billing_report_tbn' } },
        { path: '/actuals_start_events_report_tbn',    redirect: { name: 'actuals_start_events_report_tbn' } },
        { path: '/actuals_driver_payroll_report',      redirect: { name: 'actuals_driver_payroll_report' } },
        { path: '/actuals_driver_payroll_report_tbn',  redirect: { name: 'actuals_driver_payroll_report_tbn' } },
        { path: '/actuals_driver_multiday_report',     redirect: { name: 'actuals_driver_multiday_report' } },
        { path: '/actuals_driver_multiday_report_tbn', redirect: { name: 'actuals_driver_multiday_report_tbn' } },
        { path: '/actuals_payroll_summary_report',     redirect: { name: 'actuals_payroll_summary_report' } },
        { path: '/actuals_payroll_summary_report_tbn', redirect: { name: 'actuals_payroll_summary_report_tbn' } },
        { path: '/actuals_vehicle_report',             redirect: { name: 'actuals_vehicle_report' } },
        { path: '/actuals_mileage_by_booking_report',  redirect: { name: 'actuals_mileage_by_booking_report' } },
        { path: '/actuals_drivers_daily_report',       redirect: { name: 'actuals_drivers_daily_report' } },
        { path: '/actuals_hours_by_client_report',     redirect: { name: 'actuals_hours_by_client_report' } },
        { path: '/actuals_hours_by_client_report_tbn', redirect: { name: 'actuals_hours_by_client_report_tbn' } },
        { path: '/actuals_hours_by_booking_report_tbn',redirect: { name: 'actuals_hours_by_booking_report_tbn' } },
        { path: '/intrastate_booking_report_tbn',      redirect: { name: 'intrastate_booking_report_tbn' } },
        { path: '/trip_linker_report_tbn',             name: 'trip_linker_report_tbn',                 component: trip_linker_report_tbn },
        { path: '/hos_history_report',                 redirect: { name: 'hos_history_report' } },
        { path: '/planned_vehicle_daily',              redirect: { name: 'planned_vehicle_daily' } },
        { path: '/planned_vehicle_daily_tbn',          redirect: { name: 'planned_vehicle_daily_tbn' } },
        { path: '/planned_vehicle_weekly',             redirect: { name: 'planned_vehicle_weekly' } },
        { path: '/planned_vehicle_weekly_tbn',         redirect: { name: 'planned_vehicle_weekly_tbn' } },
        { path: '/planned_vehicle_types_monthly',      redirect: { name: 'planned_vehicle_types_monthly' } },
        { path: '/planned_vehicle_types_monthly_tbn',  redirect: { name: 'planned_vehicle_types_monthly_tbn' } },
        { path: '/planned_drivers_daily',              redirect: { name: 'planned_drivers_daily' } },
        { path: '/planned_drivers_daily_tbn',          redirect: { name: 'planned_drivers_daily_tbn' } },
        { path: '/planned_driver_types_monthly_cm',    redirect: { name: 'planned_driver_types_monthly_cm' } },
        { path: '/planned_driver_types_monthly_tbn',   redirect: { name: 'planned_driver_types_monthly_tbn' } },
        { path: '/planned_drivers_weekly_dispatch_tbn',redirect: { name: 'planned_drivers_weekly_dispatch_tbn' } },
        { path: '/planned_drivers_weekly_util_tbn',    redirect: { name: 'planned_drivers_weekly_util_tbn' } },
        { path: '/booking_monthly_view_tbn',           redirect: { name: 'booking_monthly_view_tbn' } },
        { path: '/hale_daily_dispatch_report_tbn',     redirect: { name: 'hale_daily_dispatch_report_tbn' } },
        { path: '/driver_board',                       redirect: { name: 'driver_board' } },
        { path: '/trip_sheet',                         name: 'trip_sheet_standalone',     component: trip_sheet },
        { path: '/trip_sheet_tbn',                     name: 'trip_sheet_tbn_standalone', component: trip_sheet_tbn },
        { path: '/dispatch_board_tbn',                 redirect: { name: 'dispatch_board_tbn' } },
        { path: '/vehicle_route_history',              name: 'vehicle_route_history_standalone',          component: vehicle_route_history },
        { path: '/vehicle_route_history/:vehicleId',   name: 'vehicle_route_history_standalone_by_id',   component: vehicle_route_history },
        { path: '/route_addresses',                    redirect: { name: 'route_addresses' } },
        { path: '/route_assignments',                  redirect: { name: 'route_assignments' } },
        { path: '/report_otp',                         redirect: { name: 'report_otp' } },
        { path: '/otp_history',                        redirect: { name: 'otp_history' } },
        { path: '/report_unplanned_vehicle',           redirect: { name: 'report_unplanned_vehicle' } },
        { path: '/report_unplanned_hos',               redirect: { name: 'report_unplanned_hos' } },
        { path: '/event_notes_list',                   redirect: { name: 'event_notes_list' } },
        { path: '/bus_tracker',                        redirect: { name: 'bus_tracker' } },
        { path: '/arrivals_departures_board',          redirect: { name: 'arrivals_departures_board' } },
        { path: '/tyler_route_processor',              redirect: { name: 'tyler_route_processor' } },
        { path: '/vehicle_status_history',             name: 'vehicle_status_history',                 component: vehicle_status_history },
        { path: '/report_converter',                   redirect: { name: 'report_converter' } },
        { path: '/vehicle_maint_summary',              redirect: { name: 'vehicle_maint_summary' } },
        // ────────────────────────────────────────────────────────────────
        {
            path: '/settings',
            name: 'settings',
            component: tenant_config_shell,
        }, {
            path: '/tenant_config_history',
            name: 'tenant_config_history',
            component: tenant_config_history,
        }, {
            path: '/tenant_config_general',
            name: 'tenant_config_general',
            component: tenant_config_general,
        }, {
            path: '/tenant_config_bookings_actuals',
            name: 'tenant_config_bookings_actuals',
            component: tenant_config_bookings_actuals,
        }, {
            path: '/tenant_config_cust_map_views',
            name: 'tenant_config_cust_map_views',
            component: tenant_config_cust_map_views,
        }, {
            path: '/tenant_config_views_reports',
            name: 'tenant_config_views_reports',
            component: tenant_config_views_reports,
        }, {
            path: '/tenant_config_alerts',
            name: 'tenant_config_alerts',
            component: tenant_config_alerts,
        }, {
            path: '/tenant_config_notifications',
            name: 'tenant_config_notifications',
            component: tenant_config_notifications,
        }, {
            path: '/tenant_config_bus_sos',
            name: 'tenant_config_bus_sos',
            component: tenant_config_bus_sos,
        }, {
            path: '/tenant_config_veh_status_mgmt',
            name: 'tenant_config_veh_status_mgmt',
            component: tenant_config_veh_status_mgmt,
        }, {
            path: '/tenant_config_data_services',
            name: 'tenant_config_data_services',
            component: tenant_config_data_services,
        }, {
            path: '/tenant_config_fleet_assistant',
            name: 'tenant_config_fleet_assistant',
            component: tenant_config_fleet_assistant,

        }, {
            path: '/actuals_mileage_cm',
            name: 'actuals_mileage_cm',
            component: actuals_mileage_cm,
        }, {
            path: '/actuals_mileage_tbn',
            name: 'actuals_mileage_tbn',
            component: actuals_mileage_tbn,
        }, {
            path: '/vehicle_map',
            name: 'vehicle_map',
            component: vehicle_map,
        }, {
            path: '/vehicle_map_future',
            name: 'vehicle_map_future',
            component: vehicle_map_future,
        }, {
            path: '/smart_route_assignments',
            name: 'smart_route_assignments',
            component: smart_route_assignments,
        },{
            path: '/smart_route_assignments_tbn',
            name: 'smart_route_assignments_tbn',
            component: smart_route_assignments_tbn,
        },{
            // FI-1432 announcement detail: users land here from the
            // notification dropdown's click-through; authorization is
            // enforced server-side (a notification row must exist).
            path: '/announcements/:announcement_id',
            name: 'announcement_detail',
            component: announcement_detail,
        },{
            // FI-1432 notifications landing page: full list of the
            // user's notifications, grouped by time, with filter chips.
            // linked from the "See all" footer in the profile dropdown.
            path: '/notifications',
            name: 'notifications_list',
            component: notifications_list,
        }, {
            path: '/fleet_assistant',
            name: 'fleet_assistant',
            component: fleet_assistant,
        }, {
            // FI-1815: ops desk (event response manager) authenticated surface.
            // single route, the event_id query param routes the component
            // into detail mode (matches the support-ticket /help_center
            // ?tab=support&ticket_id=N approach). distribution emails link
            // here via /ops_desk?tenant=<id>&event_id=<n>.
            path: '/ops_desk',
            name: 'ops_desk',
            component: ops_desk,
        }, {
            // ops board: per-yard today view of departures, vehicles out,
            // returns, and a needs-attention strip fed by the ops desk
            // verdict engine.
            path: '/ops_board',
            name: 'ops_board',
            component: ops_board,
        }, {
            // ERM Board: the event log as swim lanes — drag a card between
            // statuses (the backend transition table gates which drops the
            // board accepts; reopening a resolved event stays admin-only).
            // Same erm gate as /ops_desk, enforced in beforeEach below.
            path: '/erm_board',
            name: 'erm_board',
            component: erm_board,
        }, {
            // FI-1818 tenant admin for ops desk. settings is now a modal on
            // the ops events list; the named route is kept as a redirect so the gear,
            // first-run button, huddle "manage" link, and any deep-link land on
            // the list with the settings modal open (?settings=1). the ops events gate
            // is enforced by the ops_desk branch of beforeEach below; modal-open
            // is additionally role-gated in the component (canEditAdminFields).
            path: '/ops_desk_settings',
            name: 'ops_desk_settings',
            redirect: to => ({ name: 'ops_desk', query: { ...to.query, settings: '1' } }),
        }, {
            // staff-only vsm2 chrome, iterates on the vsm redesign
            // without touching the customer components. path deliberately
            // avoids the /vsm prefix: App.vue routes any /vsm* fullPath to
            // the chromeless standalone branches before the router runs.
            path: '/ops_vsm',
            name: 'vsm_board',
            component: vsm_board,
        }, {
            // staff-only departure board preview; /ops_departures dodges App.vue's fullPath-prefix branches the same way /ops_vsm does.
            path: '/ops_departures',
            name: 'departure_board',
            component: departure_board,
        }, {
            // FI-1813 public submission form. unauth — the route name is
            // added to publicRouteNames below so the global guard lets
            // it through without a jwt. eventually backed by the
            // ops.fleetintegrations.com/<slug> subdomain mapping; the
            // /op/<slug> path works against the existing web host today.
            path: '/op/:slug',
            name: 'ops_desk_public_form',
            component: ops_desk_public_form,
        }, {
            path: '/support_ticket_list',
            name: 'support_ticket_list',
            redirect: { name: 'help_center', query: { tab: 'support' } },
        }, {
            path: '/support_ticket_create',
            name: 'support_ticket_create',
            component: support_ticket_create,
        }, {
            // legacy redirect — kept so old Slack links / email links /
            // bookmarks shaped `/support_ticket_details?tenant_id=X&id=Y`
            // still land correctly. new URLs emitted by the backend use
            // the short form directly: `/help_center?tab=support&ticket_id=Y`
            // (no tenant_id — ticket ids are globally monotonic and the
            // server falls back to id-only lookup if the hint misses).
            path: '/support_ticket_details',
            name: 'support_ticket_details',
            redirect: to => ({
                name: 'help_center',
                query: { tab: 'support', ticket_id: to.query.id || to.query.ticket_id },
            }),
        }, {
            path: '/help_center/:articleId?',
            name: 'help_center',
            component: help_center,
        }, {
            path: '/user',
            name: 'user_list',
            component: user_list,
        }, {
            path: '/driver_list',
            name: 'driver_list',
            component: driver_list,
        }, {
            path: '/driver_list_tbn',
            name: 'driver_list_tbn',
            component: driver_list_tbn,
        }, {
            path: '/user_detail',
            name: 'user_detail',
            component: user_detail,
        }, {
            // /preferences is the target of the "email preferences" link in
            // outbound email footers, so it has to survive being opened by
            // someone who isn't logged in. it must be a COMPONENT route, not
            // a redirect: a function redirect resolves during the initial
            // navigation, before App.vue's created() captures $route.fullPath
            // as nextUrl, so a logged-out visitor would land on the dashboard
            // with no memory of what they clicked. user_detail defaults to
            // the logged-in user when no ?username is supplied.
            path: '/preferences',
            name: 'email_preferences',
            component: user_detail,
        }, {
            // /profile is a friendly alias for the current user's
            // user_detail page. announcement and help-doc authors
            // reach for "/profile" instinctively, but the real route
            // requires a ?username= query. this redirect pulls the
            // current user from the localStorage set at login and
            // forwards to /user_detail?username=<current>. falls back
            // to /dashboard when no user is logged in.
            path: '/profile',
            redirect: () => {
                try {
                    const raw = localStorage.getItem('user')
                    const u = raw ? JSON.parse(raw) : null
                    if (u && u.username) {
                        return { name: 'user_detail', query: { username: u.username } }
                    }
                } catch (_) { /* fall through */ }
                return { name: 'dashboard' }
            },
        }, {
            path: '/driver_detail',
            name: 'driver_detail',
            component: driver_detail,
        }, {
            path: '/driver_detail_tbn',
            name: 'driver_detail_tbn',
            component: driver_detail_tbn,
        }, {
            path: '/user_create',
            name: 'user_create',
            component: user_create,
        }, {
            // ── Alerts section (persistent shell + nested child routes) ────────
            // no name on the parent: vue-router drops the default child from
            // `matched` when you navigate by a parent route's name that has a
            // default (empty-path) child, leaving <router-view> with nothing
            // to render. link to the child name (alerts_dashboard) instead.
            path: '/alerts',
            component: alerts_shell,
            children: [
                { path: '',        name: 'alerts_dashboard',   component: alerts_dashboard },
                { path: 'history', name: 'alert_list',         component: alert_list },
                { path: 'failures', name: 'delivery_failures', component: delivery_failures },
                // absolute child paths keep the existing top-level URLs, but nesting
                // them here means the alerts_shell left nav stays visible while on
                // these pages, instead of unmounting on navigation like a sibling route would.
                { path: '/group_message_sender',     name: 'group_message_sender',     component: group_message_sender },
                { path: '/group_message_sender_tbn', name: 'group_message_sender_tbn', component: group_message_sender_tbn },
            ],
        }, {
            path: '/alert_list',
            redirect: '/alerts/history',
        }, {
            path: '/compare_drivers',
            name: 'compare_drivers',
            component: compare_drivers,
        }, {
            path: '/compare_driver_profiles',
            name: 'compare_driver_profiles',
            component: compare_driver_profiles,
        }, {
            path: '/compare_drivers_history',
            name: 'compare_drivers_history',
            component: compare_drivers_history,
        }, {
            // FI-2018: standalone Scorecard and Comparison pages were folded into
            // the scorecard dashboard's Individual Driver / Compare tabs. FI-2064
            // then rebranded Driver Scorecard to Driver Manager and split Individual
            // Driver / Compare back out into their own top-level pages. Old
            // links/bookmarks redirect rather than 404.
            path: '/driver_scorecard',
            redirect: to => ({ name: 'driver_manager_dashboard', query: to.query }),
        }, {
            path: '/driver_scorecard_comparison',
            redirect: to => ({ name: 'driver_manager_compare', query: to.query }),
        }, {
            path: '/driver_scorecard_dashboard',
            redirect: to => ({ name: 'driver_manager_dashboard', query: to.query }),
        }, {
            path: '/driver_manager_dashboard',
            name: 'driver_manager_dashboard',
            component: driver_manager_dashboard,
        }, {
            path: '/driver_manager_roster_list',
            name: 'driver_manager_roster_list',
            component: driver_manager_roster_list,
        }, {
            path: '/driver_manager_individual',
            name: 'driver_manager_individual',
            component: driver_manager_individual,
        }, {
            path: '/driver_manager_compare',
            name: 'driver_manager_compare',
            component: driver_manager_compare,
        }, {
            // Coaching Portal POC (Driver Manager). Role + feature guarded in
            // beforeEach below — a coaching record is a personnel record, so
            // unlike the scorecard this page is NOT reachable by bare URL.
            path: '/coaching_portal',
            name: 'coaching_portal',
            component: coaching_portal,
        }, {
            // Coaching Board: the same queue as swim lanes — drag a card to
            // move it between open and scheduled; dropping on a closed lane
            // opens the sign-off modal. Same guard.
            path: '/coaching_board',
            name: 'coaching_board',
            component: coaching_board,
        }, {
            // Coaching Stats: the measurement surface (flagged drivers,
            // recognition candidates, effectiveness, breakdowns) split out of
            // the portal so the queue stays a pure action page. Same guard.
            path: '/coaching_stats',
            name: 'coaching_stats',
            component: coaching_stats,
        }, {
            // Coaching Portal: the flagged / recognition tables as their
            // own pages. Same guard as the rest of the coaching family.
            path: '/coaching_flagged',
            name: 'coaching_flagged',
            component: coaching_flagged,
        }, {
            path: '/coaching_recognition',
            name: 'coaching_recognition',
            component: coaching_recognition,
        }, {
            path: '/driver_comparison',
            name: 'driver_comparison',
            component: driver_comparison,
        }, {
            path: '/booking_file_list',
            redirect: to => ({ name: 'booking_file_list', query: to.query }),
        }, {
            path: '/vehstatusmgr',
            name: 'vehstatusmgr',
            component: vsm_shell,
        }, {
            path: '/vehicle_status',
            name: 'vehicle_status',
            component: vehicle_status,
        }, {
            path: '/vehicle_status_es',
            name: 'vehicle_status_es',
            component: vehicle_status_es,
        }, {
            path: '/vehicle_status_dvir',
            name: 'vehicle_status_dvir',
            component: vehicle_status_dvir,
        }, {
            path: '/vehicle_status_dvir_fasttrak',
            name: 'vehicle_status_dvir_fasttrak',
            component: vehicle_status_dvir_fasttrak,
        }, {
            path: '/vehicle_status_dvir_tbn',
            name: 'vehicle_status_dvir_tbn',
            component: vehicle_status_dvir_tbn,
        }, {
            path: '/vehicle_status_maint_tbn',
            name: 'vehicle_status_maint_tbn',
            component: vehicle_status_maint_tbn,
        }, {
            path: '/vehicle_status_maint',
            name: 'vehicle_status_maint',
            component: vehicle_status_maint,
        }, {
            path: '/vehicle_status_tbn',
            name: 'vehicle_status_tbn',
            component: vehicle_status_tbn,
        }, {
            path: '/vehicle_status_upcoming_tbn',
            name: 'vehicle_status_upcoming_tbn',
            component: vehicle_status_upcoming_tbn,
        }, {
            path: '/vehicle_status_upcoming',
            name: 'vehicle_status_upcoming',
            component: vehicle_status_upcoming,
        }, {
            path: '/driver_bid_board_tbn',
            name: 'driver_bid_board_tbn',
            component: driver_bid_board_tbn,
        }, {
            path: '/driver_bid_manage_board_tbn',
            name: 'driver_bid_manage_board_tbn',
            component: driver_bid_manager_board_tbn,
        }, {
            path: '/sos_list',
            name: 'sos_list',
            component: sos_list,
        }, {
            path: '/sos_detail',
            name: 'sos_detail',
            component: sos_detail,
        }, {
            path: '/register',
            name: 'direct_register',
            component: direct_register,
        }, {
            path: '/map',
            name: 'vehicle_map_direct',
            component: vehicle_map_direct,
        }, {
            path: '/vehicle-util-monthly-tbn',
            redirect: { name: 'planned_vehicle_types_monthly_tbn' },
        }, {
            path: '/driver-util-monthly-tbn',
            redirect: { name: 'planned_driver_types_monthly_tbn' },
        }, {
            path: '/driver-util-monthly-tbn/:tenant_id',
            name: 'planned_driver_types_monthly_tbn_standalone',
            component: planned_driver_types_monthly_tbn,
        }, {
            path: '/driver-util-monthly-cm',
            redirect: { name: 'planned_driver_types_monthly_cm' },
        }, {
            path: '/driver-util-monthly-cm/:tenant_id',
            name: 'planned_driver_types_monthly_cm_standalone',
            component: planned_driver_types_monthly_cm,
        }, {
            path: '/drivermap',
            name: 'vehicle_map_driver',
            component: vehicle_map_driver,
        }, {
            path: '/vehicle_trip_history',
            name: 'vehicle_trip_history',
            component: vehicle_trip_history,
        }, {
            path: '/vehicle_trip_history/:vehicleId',
            name: 'vehicle_trip_history_by_id',
            component: vehicle_trip_history,
        }, {
            path: '/vehicle-track',
            name: 'vehicle_map_track',
            component: vehicle_map_track,
        }, {
            path: '/fleet-track',
            name: 'vehicle_map_track_fleet',
            component: vehicle_map_track_fleet,
        }, {
            path: '/fleet-track-fabbus',
            name: 'vehicle_map_track_fleet_fabbus',
            component: vehicle_map_track_fleet_fabbus,
        }, {
            path: '/booking-track',
            name: 'vehicle_map_by_booking',
            component: vehicle_map_by_booking,
        }, {
            // public shareable live-map link (Maps > Map Link Builder);
            // token resolved + window enforced server-side
            path: '/map-link/:token',
            name: 'vehicle_map_link',
            component: vehicle_map_link,
        }, {
            path: '/sos_map',
            name: 'sos_map',
            component: sos_detail,
        }, {
            path: '/vsm',
            name: 'vsm',
            component: vehicle_status_dvir,
        }, {
            path: '/vsm-v1',
            name: 'vsm_v1',
            component: vehicle_status,
        }, {
            path: '/driver-contacts',
            name: 'driver_contacts',
            component: driver_contacts,
        }, {
            path: '/status',
            name: 'status',
            component: vehicle_status_dvir_tbn,
        }, {
            path: '/vsm-tbn',
            name: 'vsm_tbn',
            component: vehicle_status_tbn,
        }, {
            path: '/vsm-upcoming-tbn',
            name: 'vsm_upcoming_tbn',
            component: vehicle_status_upcoming_tbn,
        }, {
            path: '/vsm-upcoming',
            name: 'vsm_upcoming',
            component: vehicle_status_upcoming,
        }
    ]
})


// router.beforeEach((to, _, next) => {
//     console.log("path - " + JSON.stringify(to))
//     if (to.matched[0].path.startsWith('/sos_map')) {
//         localStorage.clear()
//         localStorage.setItem('sos_detail', true)
//         router.push(to.fullPath.replace("sos_map", "sos_detail"))
//     }
//     else if (to.matched[0].path.startsWith('/map')) {
//         localStorage.clear()
//         localStorage.setItem('vehicle_map_direct', true)
//         router.push(to.fullPath.replace("map", "vehicle_map_direct"))
//     }
//     else if (to.matched[0].path.startsWith('/register')) {
//         console.log("route register map")
//         localStorage.clear()
//         localStorage.setItem('direct_register', true)
//         router.push(to.fullPath.replace("register","direct_register"))
//         //router.replace({ path: "/direct_register"})
//     }
//     else {
//         next()
//     }
// });

router.beforeEach((to, from, next) => {
    const publicRouteNames = ['login', 'login_redirect', 'ops_desk_public_form']
    if (publicRouteNames.includes(to.name)) {
        next()
        return
    }

    let user = null
    try {
        user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
    } catch (e) {
        user = null
    }

    if (!user) {
        next()
        return
    }

    // FI-2070: which tenant's feature flags this navigation is judged against.
    // the guard re-parses the localStorage 'user' blob, whose .tenant is frozen
    // at login — but the tenant picker only writes 'selected_tenant' and mutates
    // the in-memory (vuex) user, which is what the nav rail gates on. reading
    // user.tenant here made the rail and the guard disagree after any tenant
    // switch: the section rendered, the click was denied, and because the denial
    // redirects to 'dashboard' — where the user already was — vue-router aborted
    // it as a duplicate navigation, silently, with no url change and no console
    // output. resolve the same tenant the rail used.
    const actingTenant = to.query.tenant || localStorage.getItem('selected_tenant') || user.tenant
    const featuresFor = t => (user.features && user.features[t]) || {}

    if (user.role === 'booking-customer') {
        const bookingCustomerAllowedRoutes = [
            'booking_customer_list_tbn',
            'booking_customer_detail_tbn',
            'booking_customer_fleet_map',
            // reachable from the "email preferences" link in email footers.
            // without this a booking-customer clicking it gets bounced to the
            // booking list and can never turn an email off.
            'email_preferences',
        ]
        if (!bookingCustomerAllowedRoutes.includes(to.name)) {
            next({ name: 'booking_customer_list_tbn' })
            return
        }
    }

    if (user.role === 'driver' && user.tenant === 'dattco-413f464d') {
        const driverBidAllowedRoutes = ['driver_bid_board_tbn', 'vehicle_map', 'email_preferences']
        if (!driverBidAllowedRoutes.includes(to.name)) {
            next({ name: 'driver_bid_board_tbn' })
            return
        }
    }

    // FI-1929: erm is customer-rollout gated. non-staff need ops_desk_enabled
    // on their tenant plus an allowed role. settings is now a modal on this
    // route (the /ops_desk_settings route redirects here with ?settings=1),
    // and modal-open is role-gated in the component via canEditAdminFields.
    // Map Link Builder is rollout-gated per tenant (maps_link_builder_enabled,
    // off by default); staff can always view. buildMapItems hides the nav
    // entry under the same rule - this guard covers direct URL navigation.
    if (to.name === 'map_link_builder') {
        const isStaff = user.role === 'admin'
        const tenantFeatures = featuresFor(actingTenant)
        if (!isStaff && !isFeatureEnabled(tenantFeatures.maps_link_builder_enabled)) {
            next({ name: 'map_dashboard' })
            return
        }
    }

    if (['coaching_portal', 'coaching_board', 'coaching_stats', 'coaching_flagged', 'coaching_recognition'].includes(to.name)) {
        const tenantFeatures = featuresFor(actingTenant)
        // read through isFeatureEnabled so a tbn string 'false' flag can't
        // slip past the guard while the nav registry hides the link.
        const coachingEnabled = isFeatureEnabled(tenantFeatures.coaching_portal_enabled)
        // a coaching record is a personnel record: fleet admins, staff and
        // managers only (mirrors tenant_coaching_user_required server-side) —
        // drivers/dispatch/garage never reach it, even by URL. no staff
        // bypass: coaching_portal_enabled governs for everyone, so 'admin' is
        // on the role list rather than skipping the flag check.
        const isCoachingRole = ['admin', 'customer-admin', 'tbn-admin', 'customer', 'manager'].includes(user.role)
        const canView = isCoachingRole && coachingEnabled
        if (!canView) {
            next({ name: 'dashboard' })
            return
        }
    }

    // the swim-lane board shows the same events as the log, so it carries the
    // same gate — one branch, not two that could drift apart.
    if (['ops_desk', 'erm_board'].includes(to.name)) {
        const isStaff = user.role === 'admin'
        const tenantFeatures = featuresFor(actingTenant)
        // read through isFeatureEnabled so a tbn string 'false' flag can't
        // slip past the guard while the nav registry hides the link.
        const opsDeskEnabled = isFeatureEnabled(tenantFeatures.ops_desk_enabled)
        // tbn-admin is the TBN-tenant fleet admin, same tier as customer-admin;
        // both reach erm when their tenant carries ops_desk_enabled.
        const isFleetAdmin = user.role === 'customer-admin' || user.role === 'tbn-admin'
        const canView = isStaff || (isFleetAdmin && opsDeskEnabled)
        if (!canView) {
            next({ name: 'dashboard' })
            return
        }
    }

    next()
})

// FI-1860: FullStory capture control lives in utils/fullstory.js, which combines
// the route-exclusion (view-only passenger maps) with the staff-user exclusion so
// the two never fight. notify it of every navigation.
router.afterEach((to) => fsSetRoute(to.path))

export default router
